import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";
import { tokenManager } from "../../utils/tokenManager";

// REGISTER
export const registerMerchant = createAsyncThunk(
  "merchant/register",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/auth/register", formData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Registration failed" });
    }
  }
);

// VERIFY OTP
export const verifyOtpMerchant = createAsyncThunk(
  "merchant/verifyOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/auth/verify-otp", payload);

      return {
        success: true,
        userId: data?.data?.user?._id,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Invalid OTP" });
    }
  }
);

// RESEND OTP
export const resendOtpMerchant = createAsyncThunk(
  "merchant/resendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/auth/register", payload);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Unable to resend OTP" });
    }
  }
);

// LOGIN
export const loginMerchant = createAsyncThunk(
  "merchant/login",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post("api/auth/login", payload, {
        withCredentials: true, // refresh token cookie
      });

      const user = data?.data?.user;
      const accessToken = data?.data?.accessToken;

      tokenManager.setToken(accessToken);

      return { user, accessToken };
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Login failed" });
    }
  }
);

// GET PROFILE
export const getMerchantProfile = createAsyncThunk(
  "merchant/getProfile",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("api/auth/me", { withCredentials: true });
      const accessToken = data?.accessToken;

      if (accessToken) tokenManager.setToken(accessToken);

      return data.data || data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Unable to fetch profile" });
    }
  }
);

// LOGOUT
export const logoutMerchant = createAsyncThunk(
  "merchant/logout",
  async (_, { rejectWithValue }) => {
    try {
      await api.post("/api/auth/logout", {}, { withCredentials: true });
      tokenManager.clearToken();
      return true;
    } catch (err) {
      return rejectWithValue("Logout failed");
    }
  }
);

// CHECK MOBILE
export const checkMobileNumber = createAsyncThunk(
  "merchant/checkMobile",
  async (mobileNumber, { rejectWithValue }) => {
    try {
      const { data } = await api.post("api/auth/check-mobile", { mobileNumber });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Check failed" });
    }
  }
);

// merchant restore by reload the browser 
export const restoreSession = createAsyncThunk(
  "merchant/restoreSession",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("api/auth/me", {
        withCredentials: true,
      });

      return {
        user: data.data || data.user,
        accessToken: tokenManager.getToken(), // already stored
      };
    } catch (err) {
      return rejectWithValue(null);
    }
  }
);




